<form [formGroup]="form">
  <div class="period-activity-section">
    @if (( disableActivityImage$ | async ) !== true) {
      <app-asset-upload
        class="image-uploader"
        purpose="activity"
        [identifier]="'periodActivity' + sectionId"
        (uploaded)="mediaUploaded( $event )">
        <ng-template let-uploadData="uploadData">
          <div class="image-container">
            <app-doenkids-image [maxWidth]="200" [maxHeight]="200" [preview]="true" [mediaItem]="form.get('media_uuid')?.value"></app-doenkids-image>
          </div>
          @if (!form.disabled) {
            <app-select-media [uploadData]="uploadData" [removable]="true" [identifier]="'periodActivity' + sectionId" [mediaItemUuid]="form.get('media_uuid')?.value" purpose="activity" (selected)="mediaSelected( $event )"></app-select-media>
          }
        </ng-template>
      </app-asset-upload>
    }
    @if ((periodSymbols$ | async); as periodSymbols) {
      @if (periodSymbols.length > 0) {
        <mat-chip-listbox class="period-symbols">
          @for (symbol of periodSymbols; track symbol) {
            <mat-chip-option [removable]="true" (removed)="removeSymbol(symbol)" [class.outdated]="symbol.media_uuid === undefined" [matTooltip]="symbol.media_uuid === undefined ? ('period_activity_section.symbols.tooltip' | translate) : ''">
              <div class="period-symbol">
                @if (symbol) {
                  <app-doenkids-image matListItemAvatar
                  [maxWidth]="25" [maxHeight]="25" [preview]="false" [mediaItem]="{ 'uuid': symbol.media_uuid, 'description': '' }"></app-doenkids-image>
                }
                <span matListItemTitle>{{symbol?.name}}</span>
              </div>
              @if (!form.disabled) {
                <mat-icon matChipRemove>close</mat-icon>
              }
            </mat-chip-option>
          }
        </mat-chip-listbox>
      }
    }
    @if ((symbols$ | async).length > 0) {
      @if ((symbols$ | async); as symbols) {
        @if (!form.disabled) {
          <button class="customer-symbols" mat-button [matMenuTriggerFor]="menu">{{ 'period_activity_section.symbols.add' | translate }}</button>
        }
        <mat-menu #menu="matMenu">
          @for (symbol of symbols; track symbol) {
            <button mat-menu-item (click)="addSymbol(symbol)">
              <div class="period-symbol">
                <app-doenkids-image
                [maxWidth]="30" [maxHeight]="30" [preview]="false" [mediaItem]="{ 'uuid': symbol.media_uuid, 'description': '' }"></app-doenkids-image>
                <span>{{symbol.name}}</span>
              </div>
            </button>
          }
          @if (symbols.length === 0) {
            <button mat-menu-item>
              {{ 'period_activity_section.symbols.none' | translate }}
            </button>
          }
        </mat-menu>
      }
    }
    <div class="form-fields-wrapper">
      <mat-form-field appearance="outline" class="input-name">
        <mat-label>{{ 'period_activity_section.timeslot.label' | translate }}</mat-label>
        <input type="text" matInput formControlName="timeslot">
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-name">
        <mat-label>{{ 'period_activity_section.title.label' | translate }}</mat-label>
        <input type="text" matInput formControlName="title">
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-description">
        <mat-label>{{ 'period_activity_section.content.label' | translate }}</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="5" formControlName="content">
        </textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-description">
        <mat-label>{{ 'period_activity_section.additional_content.label' | translate }}</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="5" formControlName="additional_content">
        </textarea>
      </mat-form-field>
      <ng-content></ng-content>
    </div>
  </div>
</form>
